const isNumericSearchParam = (paramKey) => {
  const rangeRegex = /^ge_|^le_|^meta_/;
  return rangeRegex.test(paramKey);
};

export default isNumericSearchParam;
